import { constants, mediaQueryStyles } from "@newsela/angelou";

import { SIDE_NAV_WIDTH } from "@/browse/SideNav/SideNav.style";

const { mediaQuery: mq } = mediaQueryStyles;

const greyExtraLight = constants.colors.ui.neutral[25];
const greyDark = constants.colors.ui.neutral[600];

// Grid display areas
export const pageNavigationContainerCSS = {
  gridArea: "sideNavigation",
  height: "71px",
  position: "bottom",
  top: "0",
  width: "100%",

  [mq.downTo(constants.breakpoints.BreakpointNames.sm)]: {
    height: "100vh",
    position: "sticky",
    width: `${SIDE_NAV_WIDTH}px`,
  },
};

export const pageTitleCSS = {
  color: greyDark,
  gridArea: "pageTitle",
  margin: "2rem 2.5rem 1rem",
};

export const contentPanelContainerCSS = {
  color: greyExtraLight,
  gridArea: "contentPanel",
  margin: "1em 2.5em",
  overflow: "visible",
};

export const footerContainerCSS = {
  bottom: "0",
  gridArea: "footer",
  minHeight: "7.25em" /* Footer height */,
  padding: "0 16px",
  position: "absolute",
  width: "100%",
  [mq.between(0, constants.breakpoints.BreakpointNames.xs)]: {
    bottom: "10em",
    height: "8em",
  },
  [mq.downTo(constants.breakpoints.BreakpointNames.xs)]: {
    bottom: "7em",
  },
  [mq.downTo(constants.breakpoints.BreakpointNames.sm)]: {
    bottom: 0,
    right: 0,
  },
};

const singleTemplate = `
  "main main"
  "main main"
  "footer footer"
`;

const multiTemplate = `
  "sideNavigation main"
  "sideNavigation main"
  "sideNavigation footer"
`;

export const browseLayoutGeneratorCSS = (isSingle) => ({
  display: "grid",
  background: greyExtraLight,
  height: "auto",
  minHeight: "100wh",
  position: "relative",
  width: " 100%",
  gridTemplateAreas: `
    "main main"
    "main main"
    "footer footer"
  `,
  gridTemplateColumns: "270px 1fr" /* 270 is the width of the side panel */,
  gridTemplateRows: "auto 1fr",
  backgroundColor: greyExtraLight,

  [mq.downTo(constants.breakpoints.BreakpointNames.sm)]: {
    gridTemplateAreas: `${isSingle ? singleTemplate : multiTemplate}`,
    gridTemplateColumns: `${SIDE_NAV_WIDTH}px 1fr`,
    gridTemplateRows: "auto auto 100px",
  },
});

export const pageContainerCSS = (isSingle) => ({
  background: greyExtraLight,
  marginLeft: `${isSingle ? "0" : "-.5em"}`,
  display: "grid",
  gridArea: "main",
  gridTemplateColumns: "100%",
  gridTemplateAreas: `
    "bannerMulti"
    "pageTitle"
    "contentPanel"
    "footer"
  `,
  overflowX: "hidden",
});

export const pageContainerBrowseCSS = (isSingle) => ({
  padding: `${isSingle ? "2.5em" : ""}`,
});
